import { enumParser } from '#validation/common/parsers';
import { WorkspaceLoginMfaRequirement } from '../constants';
export const workspaceLoginMfaRequirement = enumParser(WorkspaceLoginMfaRequirement);
